import { render, staticRenderFns } from "./pay-info.vue?vue&type=template&id=e487fc54&scoped=true"
import script from "./pay-info.vue?vue&type=script&lang=js"
export * from "./pay-info.vue?vue&type=script&lang=js"
import style0 from "./pay-info.vue?vue&type=style&index=0&id=e487fc54&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e487fc54",
  null
  
)

export default component.exports